import Text from 'components/Text/Text';
import React from 'react';
import Pop from 'components/Popover/Pop';
import style from './CategoriesList.module.scss';

interface ICategoriesList {
	data: { id: string; name: string }[];
}

const CategoriesList: React.FC<ICategoriesList> = ({ data }) => {
	const CategoriesContent = () => {
		return (
			<div className={style.container}>
				{data.map((el) => (
					<div className={style.item} key={el.id}>
						<Text translationKey={el.name} size="xs" />
					</div>
				))}
			</div>
		);
	};

	return (
		<>
			{data.length > 1 ? (
				<Pop placement="bottomLeft" content={<CategoriesContent />} trigger="click">
					<div className={style.wrapper}>
						<Text translationKey={data[0].name} withTooltip={true} />
						<span className={style.showListBtn}>&middot;&middot;&middot;</span>
					</div>
				</Pop>
			) : (
				<Text translationKey={data.length ? data[0].name : '-'} withTooltip={true} />
			)}
		</>
	);
};

export default CategoriesList;
